var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.VDropdown, {
    staticClass: "be-live-following-list-select",
    attrs: {
      items: _setup.followingList,
      "key-mapper": (item) => item.id,
      value: _setup.selectedItem,
    },
    on: { change: _setup.handleFollowingListChange },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item }) {
          return [
            _c("span", { staticClass: "be-live-following-list-item" }, [
              _vm._v(" " + _vm._s(item.displayName) + " "),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }